import React from 'react';

const PreviewQuestionShell = ({ question, error, children }) => (
    <div className="ecx-survey-preview-q">
        <label className="ecx-survey-preview-q__title">
            {question.title}
            {question.required ? <span className="text-danger ms-1">*</span> : null}
        </label>
        {question.description ? (
            <p className="ecx-survey-preview-q__desc">{question.description}</p>
        ) : null}
        <div className="ecx-survey-preview-q__control">{children}</div>
        {error ? <div className="text-danger small mt-1">{error}</div> : null}
    </div>
);

export default PreviewQuestionShell;
